import { useAuthContext } from "../../context/AuthContext";

export function useLayoutItemMethods() {
  const authContext = useAuthContext();

  function onMouseClick(item) {
    switch (item.type) {
      case "bc_company":
        authContext.switchToTerminalUser(
          item.business_center_company?.company?.id,
          item.business_center_company?.terminal
        );
        break;

      default:
        break;
    }
  }

  return {
    onMouseClick,
  };
}
